import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Chart, ChartOptions } from 'chart.js';
import { Router } from '../../../../../../node_modules/@angular/router';
import { DashboardWidgetBase } from '../dashboard-widgets.base';

declare let $: any;

export class LineData {
  public data = new Array<number>();
  public labels = new Array<any>();
}

/* eslint max-classes-per-file: off */
@Component({
  selector: 'hb-line',
  templateUrl: 'line.component.html',
  styleUrls: ['line.component.scss'],
})
export class LineComponent extends DashboardWidgetBase implements OnInit, AfterViewInit {

  private lineData: LineData;
  public viewLineData = {};
  public lineOptions = {};

  @Input() set data(data) {
    if ($.isEmptyObject(data)) {
      return;
    }

    this.lineData = new LineData();
    this.lineData.labels = data.Labels;
    this.lineData.data = data.Dataset.Data;

    this.drawChart();
  }

  constructor(router: Router) {
    super(router);
  }

  private drawChart() {
    const chartCanvas = document.getElementById(this.canvasId) as HTMLCanvasElement;

    if ($.isEmptyObject(this.lineData) || !this.widgetId || !chartCanvas) {
      return;
    }

    const xCallback =  this.xAxesCallback;
    const yCallback =  this.yAxesCallback;


    const options: ChartOptions<'line'> = {
      elements: {
        line: {
          borderWidth: 1,
        },
        point: {
          radius: 4,
          hitRadius: 10,
          hoverRadius: 4,
        },
      },
      plugins:{
        legend: {
          display: false,
        },
        tooltip: {
          mode: 'index',
          intersect: false,
        },
      },
      hover: {
        mode: 'index',
        intersect: false,
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          display: true,
          ticks: {
            autoSkip: false,
            callback(value): string | number {
              const curLabel = typeof value === 'number' ? this.getLabelForValue(value) : '';

              return xCallback(curLabel);

            },
          },
        },
        y: {
          display: true,
          beginAtZero: true,
          ticks: {
            callback(value): number {
              return yCallback(value);
            },
          },
        },
      },
    };

    // Destroy the canvas before recreating
    const existingChart: Chart = Chart.getChart(chartCanvas);
    if(existingChart){
      existingChart.destroy();
    }

    new Chart(chartCanvas, {
      type: 'line',
      data: {
        labels: this.lineData.labels,
        datasets: [{
          data: this.lineData.data,
          label: 'Completed Reports',
          fill: true,
          backgroundColor: 'rgba(32, 168, 216,.2)',
          borderColor: 'rgba(32, 168, 216,.55)',
        }],
      },
      options
    });
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    setTimeout(()=>this.drawChart());
  }
}
